export default {
    'Placeholder': 'Placeholder',
}